export default {
    'Placeholder': 'Placeholder',
}